import React, { useEffect } from "react";
import { RxPerson } from "react-icons/rx";
import { GoOrganization } from "react-icons/go";
import { useState } from "react";
import { useObserver } from "mobx-react";
const Selectone = ({ setEmployerValue, isEmployer }) => {
  return useObserver(() => (
    <div className="flex flex-col mb-5">
      <h1 className="mb-2 text-lg font-semibold">Select One</h1>
      <div className="md:w-full flex gap-4 tc1:w-80 tc1:px-auto">
        <p
          className={`w-1/2 flex items-center justify-center cursor-pointer px-4 py-3 border rounded-md bg-white text-sm whitespace-nowrap ${
            !isEmployer && "!bg-primary text-white"
          } `}
          onClick={() => setEmployerValue("647ce2e8c41bee677ea39fc4")}
        >
          <span className="mr-2">
            <RxPerson size={24} />
          </span>{" "}
          Job Seeker
        </p>
        <p
          className={`w-1/2 flex items-center justify-center cursor-pointer px-4 py-3 border rounded-md bg-white text-sm whitespace-nowrap ${
            isEmployer && "!bg-primary text-white"
          } `}
          onClick={() => setEmployerValue("6551bda478cf4fd1e4316dc9")}
        >
          
          <span className="mr-2">
            <GoOrganization size={24} />
          </span>{" "}
          Organization
        </p>
      </div>
    </div>
  ));
};
export default Selectone;
